import { ruleMap } from './rules';
import { MonarchTestResult } from './types';

/* eslint-disable max-len,import/no-cycle,@typescript-eslint/consistent-type-definitions,@typescript-eslint/naming-convention,@typescript-eslint/no-explicit-any,@typescript-eslint/prefer-nullish-coalescing */
// Define a common interface for experiment results

export function useMonarchTestResult<TestResult extends MonarchTestResult>(
    experimentKey: string,
): TestResult {
    const hook = ruleMap[experimentKey];

    if (!hook) {
        throw new Error(`MonarchTest "${experimentKey}" not found`);
    }

    const result = hook() as TestResult;

    return {
        ...result,
        data: result.data || {},
    } as TestResult;
}
